<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        05.31
        <br />2016
      </span>
      <span class="tiel">美菜启动独角兽开挂模式，物廉价美出爆品！</span>
    </div>
    <div class="mat-content">
      <p align="center">
        <img
          src="https://img-oss.yunshanmeicai.com/cfile/6ed50d93e5bc9426a13704da61d3cb97.jpg"
          width="640"
        />
      </p>
      <div class="tet-js">
        清晨，天还蒙蒙亮着，街上行人不多，只偶尔响起几声汽车的鸣笛和清脆的鸟叫。街边的餐馆陆陆续续的开门准备营业，窸窣的打扫声和问候声给清晨带来一片勃勃生机。
        <br />
        <br />北京北苑家园的一家麻辣烫店刚刚开业10天，店主老王正在店门前忙上忙下的张贴海报，只听“滴滴”两声，门口停下一辆小货车。“王老板！”一声热情的招呼让老王停下手头的活儿，紧忙迎上前去。
        <br />
        <br />“王老板，早啊，菜到了！”老王抬头一看，从车上下来一位笑眯眯的年轻小伙子，带着一股清新的干劲。老王觉得很面熟，细细一想，这不是上周找自己谈蔬菜配送公司的老板刘传军吗？
        <br />
        <br />“哟！刘总，今个儿您怎么亲自来了？”
        <br />
        <br />“王老板，我今天特地来看看我们送的菜新不新鲜，顺便问问您价格还满意吗？”
        <br />
        <br />“满意、满意”，老王随机打开两个箱子验了验了货，笑的咧开了嘴，“你们的菜，新鲜，价格也公道，我自然是放心。关键省了我们不少麻烦，我再也不用起早贪黑的去批发市场砍价买菜啦！”
        <p align="center" style="padding: 40px 0 10px;">
          <img src="https://img-oss.yunshanmeicai.com/cfile/fbd255628a4d0fd26eac39bd1d12f19c.jpg" />
        </p>
      </div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>不断探索客户，你才能走在客户的前面
      </div>
      <div class="tet-js">
        这是两年前美菜刚刚成立时，创始人刘传军深入一线，跑遍全国大型的蔬菜基地及批发市场，进行调研和采购。为的就是能深度了解客户需求，不断的优化产品与服务，让美菜不仅能提供真正放心、新鲜的菜品，还能保障价格的优势。
        <br />
        <br />而这样的场景，如今每天都会在美菜的送货员与客户之间上演。
      </div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>美菜网凭什么成为行业独角兽？
      </div>
      <div class="tet-js">
        美菜网是创业邦中国年度创新成长企业100强之一，在业内有口皆碑，被认定是最具发展潜力的创新公司，有望成为行业独角兽。也许有人就要问了，凭什么呢？
        <br />
        <br />在没有生鲜电商以前，餐厅老板是按照传统采购模式进行采购：一方面农产品需要经过冗长的阶次批发环节，成本呈阶梯式增加，这不仅使流通成本过高，更加大了生鲜食材的损耗；另一方面，餐厅主采购时也受限于地域，可供选择的产品种类并不多。
        <br />
        <br />在生鲜电商出现以后，这样的状况才得以改变。
        <br />
        <br />以美菜网为例，它作为生鲜电商的典型代表，最根本的是改变旧模式，满足餐厅主的新需求。首先，改变速度。美菜网是利用电商平台进行农产品直供，在农田与餐厅之间搭起一座桥梁，让农民手中的菜快速到达餐厅的餐桌上，极大的缩短农产品流通环节。其次，改变冷链物流。生鲜电商是电商中一个特殊的群体，涉足了生鲜食品，冷链物流是必须解决的环节，而美菜网自建仓储、物流，包揽供应链。为了做好冷链物流，在相应管理和资金等方面的投入可谓不遗余力，用以保证生鲜食材质量，减少生鲜食材在运输中的损耗。第三，美菜网农产品种类齐全，从生鲜蔬果到肉禽蛋奶，从米面粮油到调料酒水，一应俱全，满足餐厅主的全部需求！
        <br />
        <br />创新的独角兽开挂模式，带来了翻天覆地的变化，从田间地到餐厅的过程，变得又快又稳。餐厅老板使用美菜后，齐全的品类，极速的物流，新鲜的蔬菜，让餐厅老板真正“翻身做地主”了！
      </div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>质量成精品，价格成爆品！
      </div>
      <div class="tet-js">
        我们再来说说价格，价格是每一个餐厅老板都会关心的。老板们看了上文，可能会以为美菜在质量保障、冷链运输等方面的投入比较多，那价格肯定不低。no,no,no，千万别这么以为。美菜采用的是源头直采模式，减少了很多中间商加价环节。另外，运输成本上省了一大笔钱。砍掉了中间的利润，价格比起传统采购来说自然降低了许多。
        <br />
        <br />真正做到物美且价廉的电商，凭这个问鼎行业，成为未来的独角兽，是绝对有潜质的，亲，拭目以待吧。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
